<template>
  <v-container class="pa-0" fluid>
    <!-- <v-card icon="mdi-clipboard-text" inline title="Service Categories"> -->
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="4" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="ml-2">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                Service Categories
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              @input="searchData"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />

            <v-btn
              small
              v-if="isWrite"
              elevation="1"
              @click="
                () => {
                  modalOk = true
                }
              "
              :class="{ 'mt-2': $vuetify.breakpoint.xs }"
              color="primary"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
      <v-divider class="my-0 py-0"></v-divider>
      <v-data-table :headers="headers" :items="tableData" :search="search" disable-pagination hide-default-footer>
        <template v-slot:item.type="{ item }">
          {{ item.type || '-' }}
        </template>

        <template v-slot:item.isActive="{ item }">
          {{ item.isActive ? 'YES' : 'NO' }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn color="success" class="px-2 ml-1 ma-1" @click="getSingle(item)" min-width="0" small>
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          <v-btn color="error" v-if="item.isActive" class="px-2 ml-1 ma-1" @click="statusUpdate(item.id)" min-width="0" small>
            <v-icon small> mdi-trash-can-outline </v-icon>
          </v-btn>
          <v-btn color="info" v-else class="px-2 ml-1 ma-1" @click="statusUpdate(item.id)" min-width="0" small>
            <v-icon small> mdi-reload </v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
      <v-col v-if="tableData.length != 0">
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="10" @input="handlePageChange"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-dialog
      persistent
      v-model="modalOk"
      max-width="900"
      :active="modalOk"
      :on-cancel="
        () => {
          modalOk = false
          clearData()
        }
      "
    >
      <form @submit.prevent="addCategory">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> {{ editMode ? 'Edit' : 'Add' }} Category</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(modalOk = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model.trim="categoryName" placeholder="Category Name" required>
                  <template v-slot:label> Name <span class="error--text ml-1">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete v-model="categoryType" :items="categoryTypeOptions" clearable label="Type" placeholder="Select Type"></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-card-actions class="justify-end">
                  <v-btn color="success" type="submit">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
import constants from '../../utils/constants'
// import VCardComponent from '@/components/template/VCardComponent'
// import MaterialCard from '@/components/template/MaterialCard'
export default {
  // components: { VCardComponent, MaterialCard },
  data () {
    return {
      modalOk: false,
      search: '',
      headers: [
        { text: 'Category name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Is Active', value: 'isActive' },
        { text: 'Actions', value: 'actions', align: 'center' }
      ],
      inProgress: false,
      tableData: [],
      isLoading: false,
      isWrite: true,
      categoryName: '',
      categoryType: '',
      categoryTypeOptions: [],
      editMode: false,
      findDataArr: [],
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },

  async created () {
    //   this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.categoryTypeOptions = Object.keys(constants.SERVICE_TYPE)
    await this.onFranchiseeChange()
  },
  methods: {
    statusUpdate: async function (id) {
      this.$dialog.warning({
        text: 'Are you sure, you want to change status ?',
        title: 'Warning',
        actions: {
          false: 'No',
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(`${CONSTANTS.API_URL}/api/service/category/status/${id}`)
                this.okMsg('Status updated successfully!')
                await this.getCategories()
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    getSingle: async function (item) {
      this.selectedId = item.id
      this.modalOk = true
      this.editMode = true
      this.categoryName = item.name
      this.categoryType = item.type || ''
    },
    addCategory: async function () {
      try {
        this.isLoading = true
        if (this.editMode) {
          await http.post(`${CONSTANTS.API_URL}/api/service/category/${this.selectedId}`, {
            name: this.categoryName,
            type: this.categoryType || ''
          })
        } else {
          await http.post(`${CONSTANTS.API_URL}/api/service/category`, {
            name: this.categoryName,
            type: this.categoryType || ''
          })
        }

        this.okMsg('Record saved successfully!')
        this.clearData()
        this.modalOk = false
        await this.getCategories()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getCategories: async function () {
      try {
        const paramData = {}
        paramData.page = this.page - 1
        paramData.size = this.pageSize
        paramData.search = this.search
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/service/category`, {
          params: paramData
        })
        this.tableData = res.data.rows
        this.totalPages = res.data.totalPages
        this.searchTerm = null
        this.total = this.tableData.length
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getCategories()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getCategories()
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getCategories()
      } else {
        this.page = 1
        this.getCategories()
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }

        await this.getCategories()
        this.inProgress = false
        this.isLoading = true
      }
    },
    clearData () {
      this.categoryName = ''
      this.categoryType = ''
      this.editMode = false
      this.selectedId = ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
